export default __webpack_public_path__ + "img/abd84e3cc3dc6a7461a223c544e81bd3.svg";